import "./chat.scss";
import { ComponentChildren, h } from "preact";
import { useState } from "preact/hooks";
import { ToolIcon, ExpandableColumn, ExpandableColumnsContainer } from "uitoolkit";

// todo: print view

// todo: optional avatar icons
// todo: optional classes to specify chat color
// todo: embedding videos
// todo: optional mini-icons under chats (such as "regenerate" for LLM responses)
// todo: popup menus for icons
// todo: setting for if the users chats are shown on the left or right
// todo: support for optional hover-popups with icons for chats (such as for reacting with an emote, or editing or forwarding)
// just like teams has chat/files/photos as tabs, this could have a side bar with files / images / videos / urls / artifacts etc
// todo: download emotes from webskype

export function ChatAndArtifact(props: {
    children: ComponentChildren,
    artifact: ComponentChildren | null,
}) {
    const [showLeft, setShowLeft] = useState(false);
    const [showRight, setShowRight] = useState(false);

    return (
        <ExpandableColumnsContainer class="chatandartifact animated">
            <ExpandableColumn hidden={!showLeft} class="artifact half ">
                <div>
                    I'm content on the left
                </div>
            </ExpandableColumn>
            <ExpandableColumn class="chat">
                <div style={{ position: "fixed", right: "0", top: "0", zIndex: 10 }}>
                    <input type="button" value="Toggle left" onClick={() => setShowLeft(!showLeft)} />
                    <input type="button" value="Toggle both" onClick={() => { setShowLeft(!showLeft); setShowRight(!showRight); }} />
                    <input type="button" value="Toggle right" onClick={() => setShowRight(!showRight)} />
                </div>
                {
                    props.children
                }
            </ExpandableColumn>
            <ExpandableColumn hidden={!showRight} class="artifact small orange">
                {
                    props.artifact
                }
            </ExpandableColumn>
        </ExpandableColumnsContainer>
    );
}

export function ContentBlock(props: { children: ComponentChildren, last?: boolean }) {
    return (
        <div class={"contentblock" + (props.last ? " expand" : "")}>
            {props.children}
        </div>
    )
}

export function CommentBlock(props: { name?: string, time?: string, children: ComponentChildren, side: "left" | "right" }) {
    return (
        <div class={"commentcontainer " + props.side}>
            {(props.name || props.time) &&
                <div class="header">
                    {
                        props.name && <span>{props.name}</span>
                    }
                    {
                        props.name && props.time && <span>, </span>
                    }
                    {
                        props.time && <span>{props.time}</span>
                    }
                </div>}
            {props.children}
        </div>
    )
}

export function Reasoning(props: { text?: string, html?: { __html: string } }) {
    return (
        <div class="reasoning">
            {props.text}
            {
                props.html?.__html &&
                <span dangerouslySetInnerHTML={props.html}></span>
            }
        </div>
    )
}

export function ToolCall(props: { text: string }) {
    return (
        <div class="toolcall">
            {props.text}
        </div>
    )
}

export function Comment(props: { text?: string, html?: { __html: string } }) {
    return (
        <div class="comment">
            {props.text}
            {
                props.html?.__html &&
                <span dangerouslySetInnerHTML={props.html}></span>
            }
        </div>
    )
}

export function UrlPreview(props: { url: string, title: string, description: string, image: string }) {
    return (
        <div class="urlpreview">
            <div style={{ backgroundImage: "url(" + props.image + ")" }}></div>
            <div>
                <h2>{props.title}</h2>
                <p>{props.description}</p>
                <div>{props.url}</div>
            </div>
        </div>
    )
}

export function ImagePreview(props: { image: string }) {
    return (
        <div class="imagepreview">
            <img src={props.image} />
        </div>
    )
}

export function ArtifactPreview(props: { title: string, subtitle: string, icon: string }) {
    return (
        <div class="artifactpreview">
            <div>
                <ToolIcon icon={props.icon} />
            </div>
            <div>
                <h2>{props.title}</h2>
                <p>{props.subtitle}</p>
            </div>
        </div>
    )
}

